import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableButton } from '@app/interfaces';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() title!: string;
  @Input() buttons: TableButton[];
  @Output() onButtonClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onClick(button: TableButton) {
    this.onButtonClick.emit({button})
  }

}
